import { Facebook, Linkedin, Instagram } from "lucide-react";
import { SOCIALS } from "@/lib/content";

const ICONS = { facebook: Facebook, linkedin: Linkedin, instagram: Instagram };

export const SocialLinks = ({ prefix, className = "" }) => (
  <ul data-testid={`${prefix}-socials`} className={`flex items-center gap-3 ${className}`}>
    {SOCIALS.map((s) => {
      const Icon = ICONS[s.id];
      return (
        <li key={s.id}>
          <a
            href={s.url}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={`${s.label} — RightAccount`}
            data-testid={`${prefix}-${s.testid}`}
            className="group inline-flex w-10 h-10 items-center justify-center border border-line text-dim hover:border-gold hover:text-gold hover:-translate-y-0.5 transition-[color,border-color,transform] duration-300"
          >
            <Icon size={16} strokeWidth={1.5} />
          </a>
        </li>
      );
    })}
  </ul>
);
